module.exports = __webpack_public_path__ + "img/img27.ab394c1c.svg";